(() => {
  function bind(root) {
    const preview = root.querySelector('[data-metzger-preview]');
    if (!preview || preview.dataset.bound === 'true') return;
    preview.dataset.bound = 'true';
    if (preview.tagName === 'DETAILS') {
      const wide = window.matchMedia('(min-width: 990px)');
      preview.open = wide.matches;
      wide.addEventListener('change', event => { if (event.matches) preview.open = true; });
    }
    const previewLabel = preview.querySelector('[data-metzger-preview-label]');
    const selectedTitle = root.querySelector('[data-metzger-selected-title]');
    const panels = Array.from(preview.querySelectorAll('[data-metzger-preview-package]'));
    const status = preview.querySelector('[data-metzger-preview-status]');
    let previous = '';
    function update() {
      const packageId = root.dataset.previewPackage;
      const grams = root.dataset.previewWeight;
      const selected = panels.find(panel => panel.dataset.metzgerPreviewPackage === packageId && panel.dataset.metzgerPreviewGrams === grams);
      // Unknown or new weights keep the complete example overview available.
      if (!selected) {
        if (previewLabel) previewLabel.textContent = 'Wechselnde Cuts · Fotos als Beispiel';
        if (selectedTitle) selectedTitle.textContent = 'Deine Auswahl';
        panels.forEach(panel => { panel.hidden = false; });
        delete preview.dataset.enhanced;
        status.textContent = 'Beispiele für beide Paketgrößen.';
        previous = '';
        return;
      }
      panels.forEach(panel => { panel.hidden = panel !== selected; });
      preview.dataset.enhanced = 'true';
      const title = selected.querySelector('h3').textContent;
      if (previewLabel) previewLabel.textContent = `${title} · ${selected.querySelector('.j-metzger-preview__heading > span').textContent}`;
      if (selectedTitle) selectedTitle.textContent = title;
      const key = `${packageId}:${grams}`;
      if (key !== previous) {
        status.textContent = `${selected.querySelector('h3').textContent} · ${selected.querySelector('.j-metzger-preview__heading > span').textContent} · Beispielauswahl`;
        previous = key;
      }
    }
    root.addEventListener('metzger:selectionchange', update);
    update();
  }
  function start(scope = document) {
    const roots = scope.matches?.('[data-metzger-selector]') ? [scope] : Array.from(scope.querySelectorAll('[data-metzger-selector]'));
    roots.forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
  else start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
